import React, { useState } from "react";
import { Field } from "formik";
import { ReactstrapInput } from "reactstrap-formik";
import * as Yup from "yup";
import { Row, Col } from "reactstrap";
import CrudEdit from "../Crud/Edit";
import PhoneNumberService from "core/api/PhoneNumberService";

const PhoneNumberSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  phoneNumber: Yup.string().required("Required"),
  notes: Yup.string(),
});

const Edit = () => {

  const initialData = {
    id: null,
    name: "",
    phoneNumber: "",
    notes: ""
  };


  return (
    <>
      <CrudEdit
        title="Phone Number"
        initData={initialData}
        crudService={PhoneNumberService}
        validationSchema={PhoneNumberSchema}>

        <Row>
          <Col>
            <Field
              type="text"
              name="name"
              label="Name"
              component={ReactstrapInput}
            />
          </Col>
          <Col>
            <Field
              type="text"
              name="phoneNumber"
              label="Phone Number"
              component={ReactstrapInput}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Field
              type="textarea"
              row="5"
              name="notes"
              label="Notes"
              component={ReactstrapInput}
            />
          </Col>
        </Row>


      </CrudEdit>
    </>
  );
};

export default Edit;
